var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.representativesMembers.length)?_c('Representatives',_vm._b({attrs:{"hide-default-footer":""}},'Representatives',{
        items: _vm.representativesMembers,
        editable: false,
        subtitle: _vm.$t('governance.organs.details.office.title')
    },false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }